import * as types from '../actions/types';
import {
  defaultSpecimens,
  caseStatus,
  CASE_PART_ONE,
  CASE_PART_TWO,
  userRoles,
} from '../../constants';

const initialState = {
  cases: [],
  specimens: [],
  selectedCase: {},
  selectedSpecimen: {},
  casePartSelected: CASE_PART_ONE,
  displayWrapper: true,
  newCaseId: null,
  renderSeadragon: true,
  showForm: true,
  portalActive: false,
  portalValues: {},
  showCadessOverlay: true,
  flagUnsavedTabs: false,
  showTabs: true,
  caseRemovedFromFilteredList: false,
  tableHasChanged: false,
  allPathologists: [],
  currentPathologist: {},
  assignedPathologists: [],
  pathologistsToAssign: [],
  pathologistsToUnassign: [],
  unsavedAnalyzes: [],
  /*
    The property below is used as a quick fix for not
    updating state, when a user choose to discard changes.
    Previously, since some components dispatches actions
    which updates state when they're about to unmount,
    the app crashed when a user logged out.
  */
  storeUnsavedChangesTemporarily: false,
};

/* The actual reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_USER_SUCCESS:
    case types.VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        storeUnsavedChangesTemporarily: true,
      };
    case types.SAVE_SPECIMENS_SUCCESS:
      return {
        ...state,
        specimens: action.payload.specimens,
      };

    case types.GO_TO_HOME:
      return {
        ...state,
        selectedSpecimen: {},
        selectedCase: {},
        casePartSelected: CASE_PART_TWO,
        displayWrapper: true,
        renderSeadragon: true,
        showForm: true, // todo should this be true?
        caseRemovedFromFilteredList: true,
      };

    case types.DELETE_CASE_SUCCESS:
      let idTemp;
      let filteredActiveList = [];
      if (action.payload._case.status.workflowStatus === caseStatus.workflowStatus.CREATE) {
        idTemp = null;
        filteredActiveList = state.cases.filter(_case => {
          return _case.status.workflowStatus !== caseStatus.workflowStatus.CREATE;
        });
      } else {
        idTemp = state.newCaseId;
        filteredActiveList = state.cases.map(_case => {
          if (_case.id === action.payload._case.id) {
            _case.status.archiveStatus = caseStatus.archiveStatus.ARCHIVED;
          }
          return _case;
        });
      }
      if (action.payload._case.id === state.selectedCase.id) {
        return {
          ...state,
          cases: filteredActiveList,
          specimens: [],
          selectedCase: {},
          selectedSpecimen: {},
          casePartSelected: CASE_PART_ONE,
          displayWrapper: true,
          newCaseId: idTemp,
          renderSeadragon: true,
          showForm: true,
          caseRemovedFromFilteredList: true,
        };
      } else {
        return {
          ...state,
          cases: filteredActiveList,
          newCaseId: idTemp,
        };
      }

    case types.ACTIVATE_CASE_SUCCESS:

      const filteredArchivedList = state.cases.map(_case => {
        if (_case.id === action.payload.id) {
          _case.status.archiveStatus = caseStatus.archiveStatus.ACTIVE;
        }
        return _case;
      });

      return {
        ...state,
        status: action.payload.status,
        selectedCase: {},
        caseRemovedFromFilteredList: true,
        cases: filteredArchivedList,

      };

    case types.GO_TO_NEXT:
      let specimenFound = false;
      const startingPoint = state.specimens.map(spec => spec._id.toString()).indexOf(state.selectedSpecimen._id.toString());
      let currentIndex = startingPoint;
      let selectedItem;
      let validationComplete = false;
      let hasLooped;
      while (!specimenFound) {

        //if last index, jump to first. Otherwise go to next
        if (currentIndex === state.specimens.length - 1) {
          currentIndex = 0;
          hasLooped = true;
        } else currentIndex++;

        selectedItem = state.specimens[currentIndex];

        //check if validation complete
        if (!selectedItem.analyses[0].validationComplete) {
          specimenFound = true
        }
        //checks if back at start position
        if (currentIndex === startingPoint && hasLooped && !specimenFound) {
          selectedItem = state.selectedSpecimen;
          specimenFound = true;
          validationComplete = true;
        }

      }
      return {
        ...state,
        selectedSpecimen: selectedItem,
        validationComplete
      };


    case types.DELETE_SNAPSHOT:
      const specs = state.specimens;
      const index = specs[state.selectedSpecimen.id - 1].snapshots
        .indexOf(action.payload.id);
      if (index > -1) {
        specs[state.selectedSpecimen.id - 1].snapshots.splice(index, 1);
      }
      return {
        ...state,
        specimens: specs,
      };
    case types.NEW_CASE_SAVED:
      return {
        ...state,
        newCaseId: null,
      };
    case types.UPDATE_SPECIMEN_TABLE: {
      const { caseId, specimens } = action.payload;
      return {
        ...state,
        specimens,
       // cases: state.cases.map(c => (c.id === caseId) ? { ...c, specimens } : c),
       // selectedCase: { ...state.selectedCase, specimens },
      };
    }
    case types.SAVE_TEMP_CASE_LEVEL:
      /* Quick fix due to crash on logout: state.storeUnsavedChanges...
         Prevent 'save-temp'-actions, dispatched when some components
         are about to unmount, to update state.
      */
      if (state.storeUnsavedChangesTemporarily) {
        return {
          ...state,
          selectedCase: {
            ...state.selectedCase,
            partTwoCaseLevelForm: action.payload.caseData,
            caseHasChanged: action.payload.hasChanged,
          },
        };
      }
      return {
        ...state,
      };
    case types.GET_PATHOLOGISTS_SUCCESS:
      return {
        ...state,
        allPathologists: action.payload,
      };
    case types.SELECT_PATHOLOGIST:
      return {
        ...state,
        currentPathologist: action.payload,
      };
    case types.SAVE_TEMP_CLINICAL_INFO:
      /* Quick fix due to crash on logout: state.storeUnsavedChanges...
         Prevent 'save-temp'-actions, dispatched when some components
         are about to unmount, to update state.
      */
      if (state.storeUnsavedChangesTemporarily && !state.caseRemovedFromFilteredList) {
        return {
          ...state,
          selectedCase: {
            ...state.selectedCase,
            partOneClinicalInformation: action.payload.partOneClinicalInformation,
            partOneGeneralInformation: action.payload.partOneGeneralInformation,
            generalHasChanged: action.payload.hasChanged,
          },
        };
      }
      return {
        ...state,
      };
    case types.GET_VALIDATION_SPECIMENS:

      return {
        ...state,
        specimens: action.payload,
      };
    case types.GET_SPECIMENS_SUCCESS:
      const specimens = action.payload.specimens.length ? action.payload.specimens : defaultSpecimens;
      let currentPathologist;
      if (action.payload.userRole === userRoles.pathologist) {
        currentPathologist = action.payload.user;
      } else if (action.payload._case.pathologists.length > 0) {
        currentPathologist = action.payload._case.pathologists[0];
      } else {
        currentPathologist = {}
      }
      return {
        ...state,
        selectedCase: action.payload._case,
        casePartSelected: CASE_PART_ONE,
        selectedSpecimen: {},
        specimens: specimens,
        flagUnsavedTabs: false,
        tableHasChanged: false,
        caseTransition: true,
        caseRemovedFromFilteredList: false,
        assignedPathologists: action.payload._case.pathologists,
        currentPathologist: currentPathologist,
        pathologistsToAssign: [],
        pathologistsToUnassign: [],
      };
    case types.REFRESH_SPECIMENS_SUCCESS:
      return {
        ...state,
        specimens: action.payload.specimens,
      };
    case types.CASE_SELECT:

      return {
        ...state,
        selectedCase: action._case,
        casePartSelected: CASE_PART_ONE,
        selectedSpecimen: {},
        flagUnsavedTabs: false,
      };
    case types.CASE_PART_SELECT:
      return {
        ...state,
        casePartSelected: action.selectedPart,
        selectedSpecimen: {},
      };
    case types.UPDATE_CASE_SUCCESS:
      return {
        ...state,
        cases: state.cases.map(aCase => {
          if (aCase.id !== action.payload._case.id) {
            return aCase;
          }
          return action.payload._case;
        }),
        selectedCase: action.payload._case,
      };
    case types.UPDATE_CASE:
      // let foundCaseAnalysis = false;

      const newAnalysisProp = {
        hasUnsavedChanges: action.payload.hasUnsavedChanges,
        analysis: action.payload.analysis,
        isValid: action.payload.isValid,
        assignee: action.payload.pathologist._id,
      }
      const casesToBe = state.cases.map(c => {
        if (c.id === action.payload.caseId) {
          if (!c.analyses.some(a => a.assignee === action.payload.pathologist._id)) {
            if (c.analyses.length) {
              return { ...c, analyses: [...c.analyses, newAnalysisProp] }
            } else {
              return { ...c, analyses: [newAnalysisProp] }

            }
          }
          const analyzesToBe = c.analyses.map(a => {
            if (a.assignee === action.payload.pathologist._id) {
              return {
                ...a,
                ...newAnalysisProp
              }
            }
            return a;
          })
          return { ...c, analyses: analyzesToBe };
        }
        return c;
      })
      const selectedCaseIndex = casesToBe.findIndex(c => c.id === state.selectedCase.id);
      return {
        ...state,
        cases: casesToBe,
        selectedCase: { ...state.selectedCase, ...casesToBe[selectedCaseIndex] }
      };

    /*    const selcaseanalyses = state.selectedCase.analyses.map(item => {
         if (item.assignee === action.payload.pathologist._id) {
           return {
             ...item,
             hasUnsavedChanges: action.payload.hasUnsavedChanges,
             analysis: action.payload.analysis,
             isValid: action.payload.isValid,
           }
         } return item;
       });
 
       const newCases = state.cases.map(_case => {
         if (_case.id === action.payload.caseId) {
           _case.analyses.map(item => {
             if (item.assignee === action.payload.pathologist._id) {
               foundCaseAnalysis = true;
               item.hasUnsavedChanges = action.payload.hasUnsavedChanges;
               item.isValid = action.payload.isValid;
               return item.analysis = action.payload.analysis;
             }
             return false;
           });
 
           if (!foundCaseAnalysis) {
             _case.analyses.push(
               {
                 assignee: action.payload.pathologist,
                 analysis: action.payload.analysis,
                 hasUnsavedChanges: true,
                 isValid: action.payload.isValid,
               }
             );
           }
           return _case;
         } else {
           return _case;
         }
       });
       return {
         ...state,
         cases: newCases,
         selectedCase: {
           ...state.selectedCase,
           analyses: selcaseanalyses
         }
       }; */
    case types.GET_CASES_SUCCESS:
      return {
        ...state,
        cases: action.res.data,
      };

    case types.SPECIMEN_TABLE_HAS_CHANGED:
      return {
        ...state,
        tableHasChanged: action.payload,
      };

    case types.SPECIMEN_ROW_HAS_CHANGED:
      return {
        ...state,
        specimens: state.specimens.map((specimen) => {
          if (specimen.id === action.id) {
            return {
              ...specimen, rowHasChanged: action.boolean,
            };
          }
          return specimen;
        }),
      };
    case types.RESET_SPECIMEN_ROW_HAS_CHANGED:
      return {
        ...state,
        specimens: state.specimens.map((specimen) => {
          return {
            ...specimen, rowHasChanged: action.boolean,
          };
        }),
      };
    case types.REFRESH_CASES_SUCCESS:
      const selectedCase = action.res.data.find(_case => _case.id === state.selectedCase.id);
      return {
        ...state,
        cases: action.res.data,
        selectedCase: selectedCase,
      };
    case types.SPECIMEN_SELECT:
      return {
        ...state,
        selectedSpecimen: action.specimen,
      };
    case types.UPDATE_CADESS_IMAGE:
      return {
        ...state,
        selectedSpecimen: {
          ...state.selectedSpecimen,
          cadessImgUrl: action.payload.cadessImgUrl,
        },
      };
    case types.TOGGLE_PORTAL:
      return {
        ...state,
        portalActive: !state.portalActive,
      };
    case types.UPDATE_PORTAL_VALUES:
      return {
        ...state,
        portalValues: action.payload.portalData,
      };
    case types.UPDATE_ANALYSIS_WHEN_OPENING_OR_CLOSING_PORTAL:

      const specimensToUpdateBecauseOfPortal = state.specimens;
      let foundAnalysis = false;
      specimensToUpdateBecauseOfPortal[action.payload.specimenId - 1].analyses.map(item => {
        if (item.assignee === action.payload.pathologist) {
          let newItem = item;
          newItem.analysis.partTwoSpecimenLevelForm = action.payload.analysis;
          found = true;
          return newItem;
        } else return item;
      });
      if (!foundAnalysis) {
        specimensToUpdateBecauseOfPortal[action.payload.specimenId - 1].analyses.push({
          analysis: {
            partTwoSpecimenLevelForm: action.payload.analysis
          },
          assignee: action.payload.pathologist,
          validationComplete: action.payload.validationComplete,
        })
      }
      return {
        ...state,
        specimens: specimensToUpdateBecauseOfPortal
      };

    case types.UPDATE_ANALYSIS:
      const specimensToUpdate = state.specimens;
      let found = false;

      const specimen = specimensToUpdate.find(specimen =>
        specimen._id.toString() === action.payload.specimenId.toString());

      if (action.payload.isValidation) {

        specimen.analyses[0] = {
          analysis: {
            partTwoSpecimenLevelForm: action.payload.analysis
          },
          hasUnsavedChanges: action.payload.hasUnsavedChanges,
          validationComplete: action.payload.validationComplete,
          assignee: action.payload.pathologist,
          analysisUpdatedAt: action.payload.analysisUpdatedAt,
        }
      } else {
        specimen.analyses.map(item => {
          if (item.assignee === action.payload.pathologist) {
            let newItem = item;
            newItem.analysis.partTwoSpecimenLevelForm = action.payload.analysis;
            newItem.hasUnsavedChanges = action.payload.hasUnsavedChanges;
            newItem.validationComplete = action.payload.validationComplete;
            if (action.payload.isValid !== undefined) newItem.isValid = action.payload.isValid;

            found = true;
            return newItem;
          } else return item;
        });
        if (!found) {
          specimen.analyses.push({
            analysis: {
              partTwoSpecimenLevelForm: action.payload.analysis
            },
            assignee: action.payload.pathologist,
            hasUnsavedChanges: action.payload.hasUnsavedChanges,
            validationComplete: action.payload.validationComplete,
            isValid: (action.payload.isValid !== undefined) ? action.payload.isValid : true,
          })
        }
      }
      return {
        ...state,
        specimens: specimensToUpdate
      };
    case "toggle-form":
      return {
        ...state,
        showForm: action.payload
      };


    case types.UPDATE_SPECIMEN:
      const mySpecimens = state.specimens.map(specimen => {
        if (action.payload.id === specimen.id) {
          return action.payload
        } else return specimen;
      });

      return {
        ...state,
        specimens: mySpecimens,
        selectedSpecimen: action.payload,
      };




    case types.UPDATE_SPECIMEN_TEMP:
      const newSpecimens = state.specimens;
      action.payload.specimen.snapshots = newSpecimens[action.payload.specimen.id - 1].snapshots;
      newSpecimens[action.payload.specimen.id - 1] = action.payload.specimen;
      return {
        ...state,
        specimens: newSpecimens,
      };
    case types.CREATE_CASE:
      const _case = {
        id: action.id,
        position: String(state.cases.length + 1), // TODO handle ID:s in a better way
        title: `New Case ${state.cases.length + 1}`,
        partOneGeneralInformation: {},
        partOneClinicalInformation: {},
        specimens: [],
        analyses: [],
        pathologists: [],
        status: {
          archiveStatus: caseStatus.archiveStatus.ACTIVE,
          workflowStatus: caseStatus.workflowStatus.CREATE,
        },
        someFormIsInvalid: true,

      };

      return {
        ...state,
        cases: [
          ...state.cases,
          _case,
        ],
        specimens: defaultSpecimens,
        selectedCase: _case,
        newCaseId: action.id,
        assignedPathologists: [],
        caseRemovedFromFilteredList: false,
      };
    case types.ASSIGN_SNAPSHOTS:
      const nSpecimens = state.specimens;
      if (nSpecimens[state.selectedSpecimen.id - 1].snapshots) {
        nSpecimens[state.selectedSpecimen.id - 1].snapshots.push(action.payload.snapshotId);
      } else {
        nSpecimens[state.selectedSpecimen.id - 1].snapshots = [action.payload.snapshotId];
      }

      return {
        ...state,
        specimens: nSpecimens,
      };
    case types.REFRESH_SEADRAGON:
      return {
        ...state,
        renderSeadragon: action.payload,
      };
    case types.TOGGLE_CADESS_OVERLAY:
      let showCadessOverlay;
      if (action.payload) {
        showCadessOverlay = action.payload;
      } else {
        showCadessOverlay = !state.showCadessOverlay;
      }
      return {
        ...state,
        showCadessOverlay: showCadessOverlay,
      };
    case types.SHOW_FORM:
      return {
        ...state,
        showForm: action.payload,
      };
    case types.ADD_SPECIMEN:
      return {
        ...state,
        specimens: [
          ...state.specimens,
          ...action.specimen,
        ],
      };
    case types.UPDATE_SPECIMEN_FIELD:
      return {
        ...state,
        specimens: state.specimens.map(specimen => {
          if (specimen.id === action.id) {
            return { ...specimen, [action.key]: action.value };
          }
          return specimen;
        }),
      };
    case types.UPLOAD_SPECIMEN_IMAGE:
      return {
        ...state,
        specimens: state.specimens.map((specimen, i) => {
          if (i === action.position) {
            return {
              ...specimen,
              imgUrl: action.data.original_image,
              cadessImgUrl: action.data.CADESS_image,
              cadessId: action.data.specimen_id,
            };
          }
          return specimen;
        }),
      };
    case types.DELETE_SPECIMEN_IMAGE:
      return {
        ...state,
        specimens: state.specimens.map((specimen, i) => {
          if (i === action.position) {
            return {
              ...specimen,
              imgUrl: '',
              cadessImgUrl: '',
              cadessId: '',
            };
          }
          return specimen;
        }),
      };
    case types.PLOT_SPECIMEN_LOCATION:
      return {
        ...state,
        specimens: state.specimens.map((specimen) => {
          if (specimen.id === action.id) {
            return { ...specimen, coordinates: action.coords };
          }
          return specimen;
        }),
      };
    case types.DISPLAY_WRAPPER:
      return {
        ...state,
        displayWrapper: !state.displayWrapper,
      };

    case types.CONFIRM_SPECIMEN_FORM_PRISTINE:
      return {
        ...state,
        specimens: state.specimens.map(specimen => {
          if (action.payload.id === specimen.id) {
            return { ...specimen, hasChanged: false };
          }
          return specimen;
        }),
        selectedSpecimen: {
          ...state.selectedSpecimen,
          hasChanged: false,
        },
      };

    case types.CONFIRM_CASE_GENERAL_PRISTINE:
      return {
        ...state,
        selectedCase: {
          ...state.selectedCase,
          generalHasChanged: false,
        },
      };
    case types.CONFIRM_CASE_LEVEL_PRISTINE:
      return {
        ...state,
        selectedCase: {
          ...state.selectedCase,
          caseHasChanged: false,
        },
      };
    case types.FLAG_UNSAVED_TABS:
      return {
        ...state,
        flagUnsavedTabs: true,
      };
    case types.SHOW_TABS:
      return {
        ...state,
        showTabs: action.payload,
      };
    case types.FLAG_GENERAL:
      return {
        ...state,
        selectedCase: {
          ...state.selectedCase,
          generalHasChanged: true,
        },
      };
    case types.FLAG_CASE_LEVEL:
      return {
        ...state,
        selectedCase: {
          ...state.selectedCase,
          caseHasChanged: true,
        },
      };
    case types.FLAG_SPECIMEN:
      return {
        ...state,
        selectedSpecimen: {
          ...state.selectedSpecimen,
          hasChanged: true,
        },
      };
    case types.SAVE_TEMP_PATHOLOGISTS_TO_ASSIGN:
      return {
        ...state,
        pathologistsToAssign: [...state.pathologistsToAssign, action.payload],
      };
    case types.REMOVE_TEMP_PATHOLOGISTS_TO_ASSIGN:
      return {
        ...state,
        pathologistsToAssign: state.pathologistsToAssign.filter((pathologistId) => action.payload !== pathologistId),
      };
    case types.SAVE_TEMP_PATHOLOGISTS_TO_UNASSIGN:
      return {
        ...state,
        pathologistsToUnassign: [...state.pathologistsToUnassign, action.payload],
      };
    case types.REMOVE_TEMP_PATHOLOGISTS_TO_UNASSIGN:
      return {
        ...state,
        pathologistsToUnassign: state.pathologistsToUnassign.filter((pathologistId) => action.payload !== pathologistId),
      };
    case types.UPDATE_ASSIGNED_PATHOLOGISTS_SUCCESS:
      //todo move this logic into some action...
      let currentPathologistUpdated = state.currentPathologist;
      const currentPathologistIsUnassigned = !action.payload.pathologists.includes(state.currentPathologist)
      if (currentPathologistIsUnassigned) {
        //set new currentPathologist if availible
        const newCurrentPathologist = action.payload.pathologists[0];
        currentPathologistUpdated = newCurrentPathologist !== undefined ? newCurrentPathologist : {}
      }
      return {
        ...state,
        cases: state.cases.map((_case) => {
          if ((_case.id) === (action.payload.caseId)) {
            return {
              ..._case,
              pathologists: action.payload.pathologists,
            };
          }
          return _case;
        }),
        selectedCase: {
          ...state.selectedCase,
          pathologists: action.payload.pathologists,
        },
        assignedPathologists: action.payload.pathologists,
        currentPathologist: currentPathologistUpdated,

      };

    case types.CLEAR_TEMP_PATHOLOGIST_ASSIGNMENT:
      return {
        ...state,
        pathologistsToAssign: [],
        pathologistsToUnassign: [],
      };
    case types.CLEAR_ASSIGNED_PATHOLOGISTS:
      return {
        ...state,
        assignedPathologists: [],
      };
    case types.STORE_UNSAVED_ANALYSIS:
      return {
        ...state,
        unsavedAnalyzes: [
          ...state.unsavedAnalyzes.filter(a => a.formId !== action.payload.formId),
          { formId: action.payload.formId, values: action.payload.values },
        ],
      };
    case types.REMOVE_STORED_UNSAVED_ANALYSIS:
      return {
        ...state,
        unsavedAnalyzes: state.unsavedAnalyzes.filter(a => a.formId !== action.payload.formId),
      };
    case types.CHECK_ALL_FORMS_VALIDITY:
      let someFormIsInvalid = false
      const specimenList = state.specimens.filter(s => state.selectedCase.specimens.includes(s._id))
      for (let i = 0; i < specimenList.length; i++) {
        const ownAnalysis = specimenList[i].analyses.find(a => a.assignee === state.currentPathologist._id);
        if (!ownAnalysis) {
          someFormIsInvalid = true;
        } else {
          if (!ownAnalysis.isValid) {
            someFormIsInvalid = true;
          }
        }
      }

      if (!someFormIsInvalid) {
        const caseAnalysis = state.selectedCase.analyses.find(a => a.assignee === state.currentPathologist._id)
        if (!caseAnalysis) {
          someFormIsInvalid = true;
        } else if (!caseAnalysis.isValid) {
          someFormIsInvalid = true;
        }
      }
      return {
        ...state,
        selectedCase: { ...state.selectedCase, someFormIsInvalid },
        cases: state.cases.map(c => {
          if (c._id === state.selectedCase._id) {
            return ({ ...c, someFormIsInvalid });
          }
          return c;
        })
      };
    default:
      return state;
  }
};

/* Selectors */
export const getIdOfSelectedPathologist = (state) => (
  state.currentPathologist._id
    ? state.currentPathologist._id
    : null
);

/**
 * @todo Remove, not relevant anymore
 */
export const getUnsavedSpecimenUploads = (state) => (
  state.specimens.filter(specimen => specimen.rowHasChanged)
);

export const checkIfChangesShouldBeTemporarilyStoredInClient = (state) => (
  state.storeUnsavedChangesTemporarily
);

export const checkIfSpecimenOverlayIsVisible = (state) => (state.showCadessOverlay);

export const checkIfASpecimenIsSelected = (state) => Boolean(state.selectedSpecimen._id);

export const getIdOfSelectedSpecimen = (state) => (state.selectedSpecimen._id);

export const getSelectedCase = (state) => (state.selectedCase);

export const getCurrentCase = (state) => (
  state.cases.find(c => c._id === state.selectedCase._id)
);

export const getIdOfSelectedCase = (state) => state.selectedCase.id;

export const getCaseGeneralInfoPropertyValueInSelectedCase = (state, property) => {
  const selectedCase = getSelectedCase(state);
  const hasInitialValue = selectedCase.partOneGeneralInformation && selectedCase.partOneGeneralInformation[`${property}`];
  const value = hasInitialValue ? selectedCase.partOneGeneralInformation[property] : '';
  return value;
};
